import { CoreIcon } from '../core-icon';
import qrcodeCircleFillSVG from '../../assets/icons/qrcode-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const QrcodeCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={qrcodeCircleFillSVG} {...props} />;
};
